/* eslint-disable no-underscore-dangle */
// @packages
import React, { useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import {
  Input,
  Icon,
  useTheme
} from '@rneui/themed';

// @scripts
import { config } from '../../../core/config';
import useStyles from './styles';

type Props = {
  control: Control,
  isRequired?: boolean
  label: string,
  leftIcon?: {name:string, type: string},
  name: string,
  placeholder: string,
  secureText?: boolean,
  isNumeric?: boolean
};

const CustomInput = ({
  control,
  isRequired = false,
  label,
  leftIcon = { name: '', type: 'material' },
  name,
  placeholder,
  secureText = false,
  isNumeric = false
}: Props) => {
  const styles = useStyles();
  const { theme } = useTheme();
  const [passwordInput, setPasswordInput] = useState({ icon: 'eye-outline', isShowed: true });

  const validate = (text:string) => {
    if (isNumeric) {
      return /^[0-9]+$/.test(text) || config.text.input.numberValidateMessage;
    }
    return true;
  };

  const hiddenPassword = () => {
    if (passwordInput.isShowed) {
      setPasswordInput({ icon: 'eye-off-outline', isShowed: false });
    } else {
      setPasswordInput({ icon: 'eye-outline', isShowed: true });
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: { value: isRequired, message: `${label} is required` }, validate: () => validate(control._formValues[name]) }}
      defaultValue=""
      render={({ field: { onChange, value }, formState: { errors } }) => (
        <Input
          containerStyle={styles.containerStyle}
          keyboardType={isNumeric ? 'number-pad' : 'default'}
          errorMessage={errors[name]?.message?.toString()}
          inputContainerStyle={styles.inputContainerStyle}
          label={label}
          labelStyle={styles.labelStyle}
          onChangeText={onChange}
          placeholder={placeholder}
          placeholderTextColor={theme.colors.grey1}
          secureTextEntry={secureText && passwordInput.isShowed}
          value={value}
          rightIcon={secureText && (
            <Icon
              color={theme.colors.grey2}
              name={passwordInput.icon}
              onPress={() => hiddenPassword()}
              size={25}
              type="ionicon"
            />
          )}
          leftIcon={!!leftIcon.name
            && (
              <Icon
                color={theme.colors.grey2}
                name={leftIcon.name}
                size={25}
                type={leftIcon.type}
              />
            )}
        />
      )}
    />

  );
};

export default CustomInput;
